import { useContext, useEffect, useState } from 'react';

import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import { Form, Select, Text } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import ModalCustom from '../../../Components/Modal/ModalCustom';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { UserContext } from '../Context/UserContext';

const User = () => {
  const context = useContext(UserContext);
  const navigate = useNavigate();
  const { get } = useApi();
  const { error } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [filterModal, setFilterModal] = useState(false);
  const [parseParams, setParseParams] = useState({});

  useEffect(() => {
    const getData = async () => {
      const params = queryString.parse(search);
      setParseParams(params);
      await getProvinces();
      await getRoles();
      await getUsers();
    };
    getData();
  }, [search]);

  const getProvinces = async () => {
    await get(
      '/province',
      (res) => {
        let data = [];
        data.push({
          id: 0,
          name: 'همه',
        });
        data.push(...res.data);
        context.provinces = data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };
  const getRoles = async () => {
    setLoading(true);
    await get(
      '/role',
      (res) => {
        let data = [];
        data.push({
          id: 0,
          name: 'all',
          description: 'همه',
        });
        data.push(...res.data);
        context.roles = data;
        setLoading(false);
      },
      (err) => {
        error('دریافت نقش ها با خطا مواجه شد');
        setLoading(false);
      },
    );
  };
  const getUsers = async () => {
    setLoading(true);
    await get(
      `/user${search}`,
      (res) => {
        context.users = res;
        setLoading(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const userFilter = (values, setSubmiting) => {
    let regexPaginate = new RegExp(/page=([0-9]+)/);
    let pageExists = regexPaginate.test(search);
    let paginate = parseParams?.page;

    let filter = pageExists ? `?page=${paginate}` : '';
    Object.entries(values).forEach((item) => {
      if (item[1] != 0 || item[1]?.length > 0) {
        filter +=
          filter.length > 0
            ? `&${item[0]}=${item[1]}`
            : `?${item[0]}=${item[1]}`;
      }
    });
    navigate(`/user${filter}`);
    setFilterModal(false);
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title='لیست کاربران'
          showCreateBtn={false}
          showFilterBtn={true}
          filter={() => setFilterModal(true)}
        />
        <Datatable
          disableAllActions={true}
          data={context.users?.data}
          editUrl='#'
          meta={context.users?.meta}
          search={search}
          basePagePath='/user'
          columns={[
            'تام',
            'نام خانوادگی',
            'استان محل زندگی',
            'کد ملی',
            'موبایل',
            'تعیین نقش',
            'نقش ها',
          ]}
          rows={[
            { name: 'name', type: 'string' },
            { name: 'last_name', type: 'string' },
            {
              name: 'province_living.name',
              type: 'relation',
              relType: 'string',
            },
            { name: 'national_card_id', type: 'string' },
            { name: 'mobile', type: 'string' },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'تعیین نقش',
              link: '/user/{id}/role',
              params: ['id'],
            },
            {
              name: 'roles',
              type: 'relationArray',
              showField: 'description',
              relType: 'string',
            },
          ]}
        />
      </Master>
      <ModalCustom modalIsOpen={filterModal}>
        <div className='d-flex flex-row justify-content-between align-items-center border-bottom pb-2'>
          <span className=''>فیلتر کاربران</span>
          <i
            className='far fa-times text-white f-20 mx-2 c-pointer'
            onClick={() => setFilterModal(false)}
          ></i>
        </div>
        <div className='w-100 my-3'>
          <Form
            initialValues={{
              name: parseParams?.name ?? '',
              last_name: parseParams?.last_name ?? '',
              national_card_id: parseParams?.national_card_id ?? '',
              role_name: parseParams?.role_name ?? 'all',
              province: parseParams?.province ?? 0,
            }}
            defaultActions={false}
            onSubmit={userFilter}
          >
            <div className='row'>
              <div className='col-12 col-md-6'>
                <Text
                  name='name'
                  className='w-100'
                  containerClass='w-100'
                  title='نام'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Text
                  name='last_name'
                  className='w-100'
                  containerClass='w-100'
                  title='نام خانوادگی'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Text
                  name='national_card_id'
                  className='w-100'
                  containerClass='w-100'
                  title='کد ملی'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='استان'
                  options={context.provinces}
                  name='province'
                  optionLabel='name'
                  optionValue='id'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='نقش'
                  options={context.roles}
                  name='role_name'
                  optionLabel='description'
                  optionValue='name'
                />
              </div>
              <div className='col-12 d-flex flex-row justify-content-center align-items-center'>
                <span
                  className='btn px-5 btn-danger text-white f-12 my-3 mx-2 c-pointer'
                  onClick={() => setFilterModal(false)}
                >
                  انصراف
                </span>
                <button className='btn px-5 btn-info text-white f-12 my-3'>
                  فیلتر
                </button>
              </div>
            </div>
          </Form>
        </div>
      </ModalCustom>
    </>
  );
};

export default User;
